import { Button } from "@material-tailwind/react";
import { t } from "i18next";

interface SignatureUploaderProps {
  localImage: string;
  setLocalImage: (s: string) => void;
  pendingFile: File | null;
  setPendingFile: (f: File | null) => void;
  canEdit: boolean;
}

export default function SignatureUploader({
  localImage,
  setLocalImage,
  pendingFile,
  setPendingFile,
  canEdit
}: SignatureUploaderProps) {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = URL.createObjectURL(file);
    setLocalImage(url);
    setPendingFile(file);
  };

  return (
    <div className="flex flex-col items-center mt-4">
      {!localImage && (
        <Button
          variant="filled"
          className="bg-blue-500 normal-case font-thin"
          onClick={() => document.getElementById("signature-upload-input")?.click()}
          disabled={!canEdit}
        >
          {t("Upload Signature")}
        </Button>
      )}
      <input
        id="signature-upload-input"
        type="file"
        className="hidden"
        accept="image/*,.pdf"
        onChange={handleFileChange}
        disabled={!canEdit}
      />
      {localImage && (
        <div className="relative w-1/2 mb-4">
          <img
            src={localImage}
            alt={t("Signature preview")}
            className="w-full h-auto rounded-lg"
          />
          <div className="absolute top-0 right-0 left-0 bg-blue-500 bg-opacity-70 text-white text-center py-1 rounded-t-lg">
            {t("Preview")}
          </div>
        </div>
      )}
    </div>
  );
} 